





















import { defineComponent } from "@vue/composition-api";
import { createNamespacedHelpers } from "vuex";
import { checkAuthorities } from "@teacherskaya/tools/dist/lib/SecurityHelpers";
import { LoggedInUser } from "@/store/types";
import config from "@/config";
import { MenuItems } from "@/types";
import { menuItems as menuItemsSettings } from "@/views/PageSettings/config";
import BaseMenu from "@/components/BaseMenu.vue";
import { mainMenuItems } from "./config";

const { mapGetters } = createNamespacedHelpers("paymentSystems");

export default defineComponent({
  name: "MainSideMenu",
  components: { BaseMenu },
  props: {
    open: { type: Boolean, default: false },
  },
  model: {
    event: "change",
    prop: "open",
  },
  setup() {
    return { needUpgrade: false };
  },
  computed: {
    loggedInUser(): LoggedInUser {
      return this.$store.state.loggedInUser;
    },
    isOpen(): boolean {
      if (this.$vuetify.breakpoint.mdAndDown) return this.open;
      return true;
    },
    small(): boolean {
      if (this.$vuetify.breakpoint.mdAndDown) return false;
      return !this.open;
    },
    disabledPages() {
      return config.disabledPages || [];
    },
    links(): MenuItems {
      const myId = this.loggedInUser.id;
      return mainMenuItems
        .filter(item => !this.disabledPages.includes(item.name))
        .map(item => {
          if (item.name === "myProfile") {
            return {
              ...item,
              route: {
                name: "profile",
                params: { userId: myId },
              },
            };
          }
          if (item.name === "settings") {
            const checked = menuItemsSettings.some(menuItem =>
              checkAuthorities(this.loggedInUser.authorities || [], menuItem.requiredAuthorities || [])
            );
            return {
              ...item,
              requiredAuthorities: checked ? [] : ["hideSettings"],
              hasBadge: false,
            };
          }
          return item;
        });
    },
    ...mapGetters(["hasSetSystem"]),
  },
  methods: {
    onInput(value: boolean) {
      if (this.small) return;
      this.$emit("change", value);
    },
  },
});
